"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLearningPathOverview = exports.mockUserLanguages = exports.mockUserLearningPath2 = exports.mockUserLearningPath = exports.mockLearningPaths = void 0;
exports.mockLearningPaths = [
    {
        uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
        name: 'Security Champion',
        description: 'Become a security champion',
        level: 'expert',
        duration: 300,
        potentialScore: 20000,
        progress: {
            status: 'in_progress',
            startedAt: '2023-06-23T12:45:21.476Z',
            completedAt: null,
            points: 6500,
        },
        createdAt: '2021-10-11T12:00:00.000Z',
        badge: 'apple',
    },
    {
        uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
        name: 'Gaming Bazz Champion',
        description: 'Become a Gamer champion',
        level: 'beginner',
        duration: 200,
        potentialScore: 30000,
        progress: null,
        createdAt: '2021-10-11T12:00:00.000Z',
    },
    {
        uuid: '8eaefbe2-bedb-4da4-96c1-68b52cf10b1a',
        name: 'Hero path Highest selection',
        description: 'Become a hero champion',
        level: 'expert',
        duration: 300,
        potentialScore: 20000,
        progress: {
            status: 'completed',
            startedAt: '2023-06-23T12:45:21.476Z',
            completedAt: '2023-06-24T12:45:21.476Z',
            points: 8500,
        },
        createdAt: '2021-10-20T12:00:00.000Z',
    },
];
exports.mockUserLearningPath = {
    id: 4,
    uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc4',
    name: 'Security Champion',
    description: 'Rimzibtep moses lu atacerev bufaid degwe efe ivpe ci mic zacad esajud judsis boluw duupufol.',
    level: 'basic',
    duration: 80,
    potentialScore: 13000,
    score: 5000,
    languages: ['java', 'php', 'c++', '.net'],
    badge: 'apple',
    nodes: [
        {
            id: 531,
            uuid: 'dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
            name: 'Lessons 2',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 345,
                    uuid: '6167f2448df887298f76a622',
                    displayName: 'Horizontal Privilege Escalation',
                    url: '/courses/java_advanced_lessons2/lessons/horizontal_privilege_escalation?learningPathNodeUuid=dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
                    status: 'not_started',
                    type: 'lesson',
                },
                {
                    id: 346,
                    uuid: '6167f2478df887cab476a62b',
                    displayName: 'XXE Processing',
                    url: '/courses/java_advanced_lessons2/lessons/xxe_processing?learningPathNodeUuid=dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [534],
            parents: [],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 532,
            uuid: 'd5af23aa-5454-49c0-b0fe-040a15de0301',
            name: 'Lessons 1',
            potentialScore: 2000,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 343,
                    uuid: '6167f2262479f1d7bcd5578f',
                    displayName: 'Broken Function-Level Authorization',
                    url: '/courses/dotnet_api_security/lessons/broken_function_level_authorization?learningPathNodeUuid=d5af23aa-5454-49c0-b0fe-040a15de0301',
                    status: 'not_started',
                    type: 'lesson',
                },
                {
                    id: 344,
                    uuid: '6167f226c27d3d66819529b5',
                    displayName: 'Brute Force Attacks ',
                    url: '/courses/dotnet_api_security/lessons/brute_force_attacks_overview?learningPathNodeUuid=d5af23aa-5454-49c0-b0fe-040a15de0301',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [535, 534],
            parents: [],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 533,
            uuid: '8a8f7729-eb8f-4ddd-8d81-fad9aed83e54',
            name: 'Lessons 5',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 349,
                    uuid: '6167f2458df887703576a625',
                    displayName: 'LDAP injection',
                    url: '/courses/java_advanced_lessons2/lessons/ldap_injection?learningPathNodeUuid=8a8f7729-eb8f-4ddd-8d81-fad9aed83e54',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [],
            parents: [534],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 534,
            uuid: 'abdfe8ce-7082-4e29-8af5-76f9c65556aa',
            name: 'Lessons 3',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 347,
                    uuid: '6167f244c27d3d9955952a13',
                    displayName: 'Insecure Object Deserialization',
                    url: '/courses/java_advanced_lessons2/lessons/insecure_object_deserialization?learningPathNodeUuid=abdfe8ce-7082-4e29-8af5-76f9c65556aa',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [533],
            parents: [531, 532],
            progressPercentage: 0,
            isMandatory: false,
        },
        {
            id: 535,
            uuid: 'f777fc63-eb9d-4da5-87e7-e915df2f9241',
            name: 'Lessons 4',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 348,
                    uuid: '6167f2442479f106acd557f5',
                    displayName: 'Insecure Password Storage',
                    url: '/courses/java_advanced_lessons2/lessons/insecure_password_storage?learningPathNodeUuid=f777fc63-eb9d-4da5-87e7-e915df2f9241',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [],
            parents: [532],
            progressPercentage: 0,
            isMandatory: true,
        },
    ],
};
exports.mockUserLearningPath2 = {
    id: 44,
    uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc456',
    name: 'Security Champion 2',
    description: 'Rimzibtep moses lu atacerev bufaid degwe efe ivpe ci mic zacad esajud judsis boluw duupufol.',
    level: 'basic',
    duration: 80,
    potentialScore: 13000,
    score: 5000,
    badge: 'apple',
    languages: ['java', 'php', 'c++', '.net'],
    nodes: [
        {
            id: 531,
            uuid: 'dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
            name: 'Lessons 2',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 345,
                    uuid: '6167f2448df887298f76a622',
                    displayName: 'Horizontal Privilege Escalation',
                    url: '/courses/java_advanced_lessons2/lessons/horizontal_privilege_escalation?learningPathNodeUuid=dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
                    status: 'not_started',
                    type: 'lesson',
                },
                {
                    id: 346,
                    uuid: '6167f2478df887cab476a62b',
                    displayName: 'XXE Processing',
                    url: '/courses/java_advanced_lessons2/lessons/xxe_processing?learningPathNodeUuid=dc80eecb-cba3-4971-b5e6-fcb3ffc22b06',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [534],
            parents: [],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 532,
            uuid: 'd5af23aa-5454-49c0-b0fe-040a15de0301',
            name: 'Lessons 1',
            potentialScore: 2000,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 343,
                    uuid: '6167f2262479f1d7bcd5578f',
                    displayName: 'Broken Function-Level Authorization',
                    url: '/courses/dotnet_api_security/lessons/broken_function_level_authorization?learningPathNodeUuid=d5af23aa-5454-49c0-b0fe-040a15de0301',
                    status: 'not_started',
                    type: 'lesson',
                },
                {
                    id: 344,
                    uuid: '6167f226c27d3d66819529b5',
                    displayName: 'Brute Force Attacks ',
                    url: '/courses/dotnet_api_security/lessons/brute_force_attacks_overview?learningPathNodeUuid=d5af23aa-5454-49c0-b0fe-040a15de0301',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [534],
            parents: [],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 533,
            uuid: '8a8f7729-eb8f-4ddd-8d81-fad9aed83e54',
            name: 'Lessons 5',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 349,
                    uuid: '6167f2458df887703576a625',
                    displayName: 'LDAP injection',
                    url: '/courses/java_advanced_lessons2/lessons/ldap_injection?learningPathNodeUuid=8a8f7729-eb8f-4ddd-8d81-fad9aed83e54',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [],
            parents: [534],
            progressPercentage: 0,
            isMandatory: true,
        },
        {
            id: 534,
            uuid: 'abdfe8ce-7082-4e29-8af5-76f9c65556aa',
            name: 'Lessons 3',
            potentialScore: 0,
            durationMinutes: 20,
            badge: {
                type: null,
                achieved: false,
            },
            items: [
                {
                    id: 347,
                    uuid: '6167f244c27d3d9955952a13',
                    displayName: 'Insecure Object Deserialization',
                    url: '/courses/java_advanced_lessons2/lessons/insecure_object_deserialization?learningPathNodeUuid=abdfe8ce-7082-4e29-8af5-76f9c65556aa',
                    status: 'not_started',
                    type: 'lesson',
                },
            ],
            status: null,
            score: 0,
            children: [533],
            parents: [531, 532],
            progressPercentage: 0,
            isMandatory: false,
        },
    ],
};
exports.mockUserLanguages = {
    web: {
        java: 1,
        php: 2,
    },
    mobile: {
        ios: 1,
    },
};
exports.mockLearningPathOverview = {
    uuid: 'e8a5c18f-6c23-4fdd-9e99-d265c85d4cc4',
    name: 'Security Champion',
    description: 'Rimzibtep moses lu atacerev bufaid degwe efe ivpe ci mic zacad esajud judsis boluw duupufol.',
    level: 'basic',
    duration: 80,
    points: 13000,
    status: 'in_progress',
    progress: 35,
    itemsByContentType: {
        lesson: [
            {
                name: 'Privileged Interface Exposure',
                status: 'not_started',
            },
            {
                name: 'Unprotected Background Screenshots',
                status: 'not_started',
            },
            {
                name: 'Insecure Local Storage',
                status: 'started',
            },
            {
                name: 'Sensitive Data in Plist File',
                status: 'not_started',
            },
            {
                name: 'Client Side Injection',
                status: 'not_started',
            },
            {
                name: 'HTTP GET and POST Requests: Overview',
                status: 'completed',
            },
            {
                name: 'HTTP Response Splitting',
                status: 'completed',
            },
            {
                name: 'Flask Panel XSS',
                status: 'not_started',
            },
            {
                name: 'Password Storage',
                status: 'completed',
            },
            {
                name: 'SQL Injection',
                status: 'completed',
            },
            {
                name: 'XXE Processing',
                status: 'not_started',
            },
            {
                name: 'Command Injection',
                status: 'not_started',
            },
            {
                name: 'Web Cache Deception',
                status: 'not_started',
            },
        ],
        challenge: [
            {
                name: 'Java For Beginners 2',
                status: 'not_started',
            },
        ],
        course: [
            {
                name: 'Front End Security Basics',
                status: 'not_started',
            },
        ],
    },
};
